import type { CSSProperties, ReactNode, Ref } from "react";
import { cn } from "@/lib/utils";
import { useInViewOnce } from "./useInViewOnce";

/**
 * Fait monter et apparaître son contenu quand il entre dans la fenêtre
 * (classe `enc-reveal`, styles/motion.css). `delay` décale l'apparition
 * pour enchaîner plusieurs blocs ; `as="li"` le range dans une liste.
 * Sans mouvement : visible d'emblée.
 */
export function Reveal({
  children,
  delay = 0,
  as: Tag = "div",
  className,
}: {
  children: ReactNode;
  delay?: number;
  as?: "div" | "li";
  className?: string;
}) {
  const { ref, shown } = useInViewOnce<HTMLElement>();
  const style = delay
    ? ({ "--reveal-delay": `${delay}ms` } as CSSProperties)
    : undefined;
  return (
    <Tag
      ref={ref as Ref<HTMLDivElement & HTMLLIElement>}
      data-shown={shown}
      className={cn("enc-reveal", className)}
      style={style}
    >
      {children}
    </Tag>
  );
}
